'use es6';

import { createStore, applyMiddleware, compose } from 'redux';
import rootReducer from 'AdsUI/reducers/rootReducer';
import CustomNotificationMiddleware from 'AdsUI/middleware/NotificationMiddleware';
import FailedActionMiddleware from 'AdsUI/middleware/FailedActionMiddleware';
import NotificationMiddleware from 'ReduxMessenger/middleware/NotificationMiddleware';
import ActionNotificationHandlers from 'AdsUI/lib/ActionNotificationHandlers';
import thunk from 'redux-thunk';
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const configureStore = initialState => {
  const middleware = [thunk, NotificationMiddleware, CustomNotificationMiddleware(ActionNotificationHandlers), FailedActionMiddleware];
  return createStore(rootReducer, initialState, composeEnhancers(applyMiddleware(...middleware)));
};

const store = configureStore();
export default store;